"use client";

import dynamic from "next/dynamic";

export const SpeechEngineWrapper = dynamic(() => import("./SpeechEngine").then(mod => mod.SpeechEngine));
